import { Prezzo } from './../Models/Prezzo';
import { ProdottiStoreService } from './prodotti-store.service';
import { ClassicType } from './../../shared/models/ClassicType';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RitornoPaginazione } from 'src/app/shared/models/RitornoPaginazione';
import { Progetto } from './../Models/Progetto';
import { ApiRestService } from './api-rest.service';

@Injectable({
  providedIn: 'root'
})
export class ProgettiStoreService {
  constructor(private apiRestService: ApiRestService, private prodottiStore: ProdottiStoreService) { }
  private EDITABLE = new BehaviorSubject<boolean>(false);
  private SHOW_ADD_FORM = new BehaviorSubject<boolean>(false);
  private STAMPE = new BehaviorSubject<any[]>([]);
  private EMAIL = new BehaviorSubject<any[]>([]);
  private STATI_PROGETTI = new BehaviorSubject<ClassicType[]>([]);
  private PROGETTI = new BehaviorSubject<RitornoPaginazione<Progetto[]>>(null);
  private PROGETTO_SELEZIONATO = new BehaviorSubject<Progetto>(null);
  private SHOW_ALL_PROGETTI = new BehaviorSubject<boolean>(false);
  private SOTTO_OFFERTE = new BehaviorSubject<Progetto[]>([]);
  private dataStore: {
    Stampe: any[],
    Email: any[],
    Editable: boolean,
    ShowAddForm: boolean,
    StatiProgetto: ClassicType[],
    Progetti: RitornoPaginazione<Progetto[]>,
    ProgettoSelezionato: Progetto,
    ShowAllProgetti: boolean,
    SottoOfferte: Progetto[],
  } = {
    Stampe: [],
    Email: [],
      Editable: false,
      ShowAddForm: false,
      StatiProgetto: [],
      Progetti: null,
      ProgettoSelezionato: null,
      ShowAllProgetti: false,
      SottoOfferte: []
    }
  readonly $editable = this.EDITABLE.asObservable();
  readonly stampe = this.STAMPE.asObservable();
  readonly email = this.EMAIL.asObservable();
  readonly $showAddForm = this.SHOW_ADD_FORM.asObservable();
  readonly $statiProgetto = this.STATI_PROGETTI.asObservable();
  readonly $progetti = this.PROGETTI.asObservable();
  readonly $progettoSelezionato = this.PROGETTO_SELEZIONATO.asObservable();
  readonly $showAllProgetti = this.SHOW_ALL_PROGETTI.asObservable();
  readonly $sottoOfferte = this.SOTTO_OFFERTE.asObservable();
  refreshStampe = () => this.STAMPE.next(Object.assign({}, this.dataStore).Stampe);
  refreshEmail = () => this.EMAIL.next(Object.assign({}, this.dataStore).Email);
  refreshEditable = () => this.EDITABLE.next(Object.assign({}, this.dataStore).Editable);
  refreshShowAddForm = () => this.SHOW_ADD_FORM.next(Object.assign({}, this.dataStore).ShowAddForm);
  refreshStatiProgetto = () => this.STATI_PROGETTI.next(Object.assign({}, this.dataStore).StatiProgetto);
  refreshProgetti = () => this.PROGETTI.next(Object.assign({}, this.dataStore).Progetti);
  refreshProgettoSelezionato = () => this.PROGETTO_SELEZIONATO.next(Object.assign({}, this.dataStore).ProgettoSelezionato);
  refreshShowAllProgetti = () => this.SHOW_ALL_PROGETTI.next(Object.assign({}, this.dataStore).ShowAllProgetti);
  refreshSottoOfferte = () => this.SOTTO_OFFERTE.next(Object.assign({}, this.dataStore).SottoOfferte);

  getStatiProgetto() {
    this.apiRestService.getStatiProgetto().subscribe(data => {
      this.dataStore.StatiProgetto = data;
      this.refreshStatiProgetto();
    });
  }
  getProgetti(value, restRoute?) {
    if (!this.dataStore.ShowAllProgetti) {
      this.apiRestService.getProgetti(value, restRoute)
        .subscribe(data => {
          this.dataStore.Progetti = data;
          this.refreshProgetti();
          return this.$progetti;
        })
    } else {
      return this.getAllProgetti(value,restRoute);
    }
  }
  getAllProgetti(value, restRoute?) {
    this.apiRestService.getAllProgetti(value, restRoute)
      .subscribe(data => {
        this.dataStore.Progetti = data;
        this.refreshProgetti();
        return this.$progetti;
      })
  }
  updateSottoOfferte(value: Progetto[]){
    this.dataStore.SottoOfferte = value;
    this.refreshSottoOfferte();
  }
  updateShowAllProgetti(value: boolean) {
    this.dataStore.ShowAllProgetti = value;
    this.refreshShowAllProgetti();
  }
  updateShowAddForm(value: boolean) {
    this.dataStore.ShowAddForm = value;
    this.refreshShowAddForm();
  }
  updateEditable(value: boolean) {
    this.dataStore.Editable = value;
    this.refreshEditable();
  }
  updateProgettoSelezionato(value: any) {
    if(value && value.id)
      this.apiRestService.getUnitaDiMisura().subscribe(um=>{
        this.apiRestService.getInfoProgetto(value).subscribe(async data => {
          this.dataStore.ProgettoSelezionato = data.data;
          this.dataStore.Stampe = data.stampe;
          this.dataStore.Email = data.invio;
          if (this.dataStore.ProgettoSelezionato && this.dataStore.ProgettoSelezionato.progetti) {
            this.dataStore.ProgettoSelezionato.progetti.forEach(progetto => {
              if (progetto) {
                if (!progetto.sede_id)
                  progetto.sede_id = null;
                progetto.voci.forEach(item => {
                  if (item.um_id > 0) {
                    if (item?.prezzi?.length > 0)
                      item.um_list = this.umList(item.prezzi);
                    else
                      item.um_list = um;
                    item.umSelezionabili = item.um_list;
                    item.um = item.um_list?.filter(data => data?.id?.toString() == item?.um_id?.toString()) ?? [];
                  }
                });
              }
            });
          }
          this.refreshProgettoSelezionato();
          this.refreshStampe();
          this.refreshEmail();
        });
      })
    else {
      this.dataStore.ProgettoSelezionato = value;
      if (this.dataStore.ProgettoSelezionato && this.dataStore.ProgettoSelezionato.progetti) {
        this.dataStore.ProgettoSelezionato.progetti.forEach(progetto => {
          if (progetto) {
            if (!progetto.sede_id)
              progetto.sede_id = null;
            progetto.voci.forEach(item => {
              if (item.um_id > 0) {
                if (item.prezzi && item.prezzi != null && item.prezzi.length > 0)
                  item.um_list = this.umList(item.prezzi);
                item.umSelezionabili = item.um_list;
                item.um = item.um_list.filter(data => data.id.toString() == item.um_id.toString());
              }
            });
          }
        });
      }
      this.refreshProgettoSelezionato();
    }
  }

  umList(value: Prezzo[]): ClassicType[] {
    const output: ClassicType[] = [];
    value.forEach(item => {
      output.push({id: item.um.toString(), label: item.umlabel});
    })
    return output;
  }


}
